// src/config.js

// ✅ Change this ONE line when deploying
const IS_PRODUCTION = false; // Set to true for cPanel, false for localhost

// Configuration for both environments
const config = {
    // Local Development
    development: {
        API_URL: 'http://localhost:8000/api',
        API_BASE_URL: 'http://localhost:8000',
        IMAGE_BASE_URL: '',
        APP_NAME: 'PITAC (Local)',
    },
    // Production (cPanel)
    production: {
        API_URL: 'http://localhost:8000/api',
        API_BASE_URL: 'http://localhost:8000',
        IMAGE_BASE_URL: '',
        APP_NAME: 'PITAC (Production)',
    }
};

// Export the appropriate config
export default IS_PRODUCTION ? config.production : config.development;